import { AuthResponse, UserState } from 'ducks/user'

export const parseAuthResponse = ({ jwt, user }: AuthResponse): UserState => ({
  token: jwt,
  id: user.id,
  name: user.username,
  email: user.email,
})
